import { IPartnerDuplicate } from 'clickNgo/entities/partner/models'

import { renderTableProperties } from './helpers/renderTableProperties'
import { IPartnerDuplicatesContentColumns } from './models'

export const RESULT_CONFIG: IPartnerDuplicatesContentColumns[] = [
  {
    priority: 2,
    title: 'bpreg-company-name',
    field: 'communicationName',
  },
  {
    hideSettings: true,
    disableSort: false,
    priority: 3,
    title: 'partner-apollo-partnerId',
    field: 'partnerId',
  },
  {
    priority: 4,
    title: 'jbp-masterdealer-partner-type',
    field: 'partnerType',
  },
  {
    priority: 4,
    title: 'jbp-masterdealer-hierarchy',
    field: 'hierarchyType',
  },
  {
    priority: 5,
    title: 'partnersearch-dropdown-country',
    field: 'country',
  },
  {
    priority: 6,
    title: 'partnersearch-dropdown-state',
    field: 'state',
  },
  {
    priority: 7,
    title: 'partnersearch-input-city',
    field: 'city',
  },
  {
    priority: 9,
    title: 'bpreg-comp-inf-postcode',
    field: 'zipCode',
  },
  {
    priority: 10,
    title: 'partner-apollo-address-line1',
    field: 'addressLine1',
  },
  {
    priority: 11,
    title: 'partner-apollo-address-line2',
    field: 'addressLine2',
  },
  {
    priority: 12,
    title: 'partner-apollo-address-line3',
    field: 'addressLine3',
  },
  {
    priority: 8,
    title: 'partner-apollo-taxid',
    field: 'taxId',
  },
]

export const columns: IPartnerDuplicatesContentColumns[] = RESULT_CONFIG.map((col) => ({
  ...col,
  renderFunction: ({ partner }: IPartnerDuplicate) =>
    renderTableProperties({ item: partner, fieldName: col.field }),
}))
